import Order from './Order';
import ArticleGroup from './ArticleGroup';
import Payment from './Payment';
import Customer from './Customer';
import OneClickPaymentMethod from './OneClickPaymentMethod';
import * as moment from 'moment';
import { OrderUtils } from '../utils/order-utils';
import { sanitizeId } from '../api/api';

export function orderBody(order: Order) {
	let orderAt = moment(order.orderAt).utc();
	orderAt = orderAt.seconds(0);
	orderAt = orderAt.milliseconds(0);
	let promoCode: string = null;
	if (order.promoCode) {
		if (order.promoCode._id) {
			promoCode = order.promoCode._id;
		} else {
			promoCode = order.promoCode;
		}
	}
	// @ts-ignore
	order.preorder.deliveryFeeNet = undefined;
	return {
		_id: order._id,
		venue: order.venue,
		session: order.session,
		status: order.status,
		type: order.type,
		preorder: order.preorder,
		orderAt: orderAt.toISOString(),
		flavor: order.flavor,
		orderedArticles: order.orderedArticles.map(value => ArticleGroupConverter.toBody(value)),
		table: order.table,
		terminalorder: order.terminalorder,
		promoCode,
	};
}

export function customerBody(customer: Customer) {
	return {
		_id: customer._id,
		name: customer.name,
		street: customer.street,
		city: customer.city,
		postalCode: customer.postalCode,
		companyName: customer.companyName,
		preferredVenue: customer.preferredVenue,
		floor: customer.floor,
		country: customer.country,
		subcard: customer.subcard,
		number: customer.number,
		userUid: sanitizeId(customer.userUid),
		paymentMethods: customer.paymentMethods
			? customer.paymentMethods.map(ocp => {
				return {
					_id: ocp._id,
					maskedAccountNumber: ocp.maskedAccountNumber,
					tokenId: ocp.tokenId,
					expiresAt: ocp.expiresAt,
					transactionType: ocp.transactionType,
					type: ocp.type,
				};
			})
			: [],
		gender: customer.gender,
		phone: customer.phoneCountry ? customer.phoneCountry.tel.substr(1) + customer.phone : customer.phone,
		email: customer.email,
	};
}

export function paymentBody(payment: Payment) {
	return {
		_id: payment._id,
		orders: payment.orders.map(order => {
			if (order.hasOwnProperty('_id')) {
				return order._id;
			} else {
				return order;
			}
		}),
		response: payment && payment.response ? JSON.parse(JSON.stringify(payment.response)) : null,
		session: payment.session,
		status: payment.status,
		method: payment.method,
		sum: payment.sum,
		transactionType: payment.transactionType,
	};
}

export function ocpPaymentBody(ocp: OneClickPaymentMethod, order: Order) {
	return {
		orders: [order._id],
		sum: OrderUtils.orderTotalPrice(order),
		method: ocp.type,
		session: order.session,
		ocp: ocp._id,
	};
}

export class ArticleGroupConverter {
	static toBody(articleGroup: ArticleGroup) {
		return {
			article: articleGroup.article._id,
			quantity: articleGroup.quantity,
			groups: articleGroup.groups.map(value => {
				return {
					group: value.group,
					article: value.article._id,
					quantity: value.quantity,
					dependsOn: value.dependsOn,
					dependency: value.dependency,
					dependencyNumber: value.dependencyNumber,
				};
			}),
			isRecommendedRecipe: articleGroup.isRecommendedRecipe,
			freeArticle: articleGroup.freeArticle,
			isPromo: articleGroup.isPromo,
			note: articleGroup.note,
		};
	}
}
